import { isClient } from './browserUtils';
import { getProctor } from '../browser-store';
import {
    getActiveTestBucket,
    getProctorBucketValue,
    isProctorBucketActiveByName,
    isProctorBucketActiveByValue,
} from '@indeed/frontend-proctor-utils';

// FIXIT: Remove once jpham removes all isInProctorGroup references in components
export const getClientProctorData = () => {
    if (isClient) {
        try {
            return getProctor().getProctorData();
        } catch (e) {
            return { proctorGroups: {} };
        }
    } else {
        return {};
    }
};

const getTestDataWithProctorData = (tstName, proctorData) => {
    return getActiveTestBucket(proctorData.proctorGroups, tstName);
};

export const isInProctorGroupWithProctorData = (tstName, value, proctorData) => {
    // check for group match
    if (isNaN(value)) {
        return isProctorBucketActiveByName(proctorData.proctorGroups, tstName, value);
    }

    // check for value match
    return isProctorBucketActiveByValue(proctorData.proctorGroups, tstName, value);
};

export const isInProctorGroup = (tstName, value) => {
    return isInProctorGroupWithProctorData(tstName, value, getClientProctorData());
};

export const isInProctorGroups = (tstName, values) => {
    for (let i = 0; i < values?.length; i++) {
        if (isInProctorGroupWithProctorData(tstName, values[i], getClientProctorData())) {
            return true;
        }
    }

    return false;
};

export const PROCTOR_PAYLOAD_TYPES = {
    LONG_ARRAY: 'longArray',
    JSON: 'json',
};

export const getProctorPayloadWithProctorData = (tstName, payloadType, proctorData) => {
    const testData = getTestDataWithProctorData(tstName, proctorData);

    if (testData) {
        return testData.payload ? testData.payload[payloadType] : undefined;
    }

    return null;
};

export const getProctorPayload = (tstName, payloadType) => {
    return getProctorPayloadWithProctorData(tstName, payloadType, getClientProctorData());
};

export const getProctorValue = (tstName) => {
    const proctorData = getClientProctorData();
    return getProctorBucketValue(proctorData.proctorGroups, tstName);
};
